import request from '@/utils/request';
import store from '@/store';

// 上传
export function upload(data) {
    const formData = new FormData();
    formData.append("formfile", data.file);
    formData.append("type", data.type); // 附件类型，1为普通附件，2为合同附件
    formData.append("tenant", store.getters.tenantId || null);
    formData.append("kind", store.getters.routerId || "admin");
    return request({
        url: '/fwUpload',
        method: 'put',
        data: formData,
        name: 'upload',
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

// 上传
export function uploadCutImg(data, fileName) {
    const formData = new FormData();
    formData.append("formfile", data, fileName);
    formData.append("tenant", store.getters.tenantId || null);
    formData.append("kind", store.getters.routerId || "admin");
    return request({
        url: '/fwUpload',
        method: 'put',
        data: formData,
        name: 'upload',
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function uploadCommImg(data) {
    const formData = new FormData();
    formData.append("formfile", data.file, data.fileName);
    formData.append("tenant", store.getters.tenantId || null);
    formData.append("kind", store.getters.routerId || "admin");
    return request({
        url: '/cscommunity/enclosure/upload',
        method: 'put',
        data: formData,
        timeout: 12000, // 单独设置超时时间
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function xdUpload(data) {
    const formData = new FormData();
    formData.append("formfile", data.file);
    formData.append("tenant", store.getters.tenantId || null);
    formData.append("kind", store.getters.routerId || "admin");
    return request({
        url: '/xdUpload',
        method: 'put',
        data: formData,
        name: 'upload',
        timeout: 12000, // 单独设置超时时间
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function exportFile(url, data) {
    return request({
        url: url,
        method: 'post',
        data: data,
        responseType: 'arraybuffer'
    });
}

export function downLoadByUrl(url, data) {
    return request({
        url: url,
        method: 'post',
        data: data
    });
}

export function downLoadYUNByUrl(url, data) {
    return request({
        url: url,
        method: 'get',
        name: 'upload',
        data: data
    });
}

export function downLoadPPTByUrl(url, data) {
    return request({
        url: url,
        method: 'post',
        name: 'ppt',
        data: data
    });
}

export function uploadTxImg(data) {
    return request({
        url: '/uploadByUrl?url=' + data.eurl + '&tenant=' + store.getters.tenantId || null,
        method: 'get',
        name: 'upload'
    });
}


